import { ModulosCliente } from "../../../../pages/manager/customers/components/forms/ModulosCliente";
import { ModuleUnderConstruction } from "../../../../components/ModuleUnderConstruction";

export const ReferidosComerciales = () => {
  return (
    <>
      <ModuleUnderConstruction moduleName='Calificaciones / Referidos Comerciales' />
    </>
  );
};
